import type { IncomingReq } from "./domainTypes";

/** Lowercase a-z, 0-9, underscore; length 1…USERNAME_MAX_LEN. */
export const USERNAME_MAX_LEN = 16;

export function normalizeUsername(raw: string): string {
  const s = raw.trim().toLowerCase().replace(/[^a-z0-9_]/g, "");
  if (s.length < 1 || s.length > USERNAME_MAX_LEN) return "";
  return s;
}

export function mergeIncoming(prev: IncomingReq[], next: IncomingReq[]): IncomingReq[] {
  const map = new Map<string, IncomingReq>();
  for (const item of prev) map.set(item.from_id, item);
  for (const item of next) map.set(item.from_id, item);
  return [...map.values()].sort((a, b) => a.username.localeCompare(b.username));
}
